var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveTvOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.07141V14.0714L12 11.0714L6.75 8.07141ZM15.75 5.07141H10.065L12.5325 2.60391L12 2.07141L9 5.07141H8.9775L5.9775 2.07141L5.46 2.60391L7.92 5.07141H2.25C1.425 5.07141 0.75 5.74641 0.75 6.57141V15.5714C0.75 16.3964 1.425 17.0714 2.25 17.0714H15.75C16.575 17.0714 17.25 16.3964 17.25 15.5714V6.57141C17.25 5.74641 16.575 5.07141 15.75 5.07141ZM15.75 15.5714H2.25V6.57141H15.75V15.5714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTvOutlined);
export default __webpack_public_path__ + "static/media/LiveTvOutlined.09ed8cbab99430287b1f4fc57d7cf302.svg";
export { ForwardRef as ReactComponent };